<template>
  <van-popup v-model="show" :overlay=false :style="{ width: '100%', height: '100vh' }">
    <div class="tx-details-container">
      <!-- 标题栏 -->
      <div class="pc-title">
        <p class="icon">
          <i @click="closePopup" class="el-icon-arrow-left"></i>
        </p>
        <span>今日交易详情</span>
        <img class="icon1" src="~@/assets/imgs/icon/tip1.svg" alt="">
      </div>

      <!-- 交易列表 -->
      <div class="tx-list">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多数据了"
            :error.sync="error"
            error-text="请求失败，点击重新加载"
            @load="onLoad"
        >
          <div class="tx-group" v-for="(group, index) in transactionGroups" :key="index">
            <!-- 日期和交易哈希 -->
            <div class="tx-date-row">
              <div class="tx-date">
                <img class="icon1" src="~@/assets/imgs/icon/date.svg" alt="">
                <span>{{ group.date }}</span>
              </div>
              <div class="tx-hash" @click="openExplorer(group.txHash)">
                {{ formatAddress(group.txHash) }}
              </div>
            </div>

            <!-- 交易详情 -->
            <div class="tx-item-p">
<!--              v-for="(tx, txIndex) in group.transactions" :key="txIndex"-->
              <div class="tx-item">
                <div class="tx-tokens">
                  <div class="token-icon">
                    <img  :src="group.fromTokenImageUrl" alt="">
                    <img  :src="group.toTokenImageUrl" alt="">
                  </div>
                  <div class="token-from">{{ group.fromTokenSymbol }}</div>
<!--                  <i class="el-icon-right arrow"></i>-->
                  <img class="arrow" src="~@/assets/imgs/icon/jt.svg" alt="">
                  <div class="token-to">{{ group.toTokenSymbol }}</div>
                </div>
                <div class="tx-amount font2 positive" v-if="group.fromTokenSymbol == 'USDT'">
                  +{{ $formatDecimals(group.volume) }}
                </div>
                <div class="tx-amount font2 positive" v-else-if="group.fromTokenSymbol == 'WBNB'">
                  +{{ $formatDecimals(group.volume) }}
                </div>
                <div class="tx-amount font2 negative" v-else>
                  -{{ $formatDecimals(group.volume) }}
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>

      <!-- 底部统计 -->
      <div class="tx-summary">
        <div class="summary-item">
          <div class="summary-label">今日累计买入: </div>
          <div class="summary-value positive font2">+{{ $formatWithCommas(totalBuyAmount) }}</div>
        </div>
        <div class="summary-item">
          <div class="summary-label">今日累计卖出: </div>
          <div class="summary-value negative font2">-{{ $formatWithCommas(totalSellAmount) }}</div>
        </div>
        <div class="next-level">
          <div class="next-level-text ">距离下个积分等级还差: <span>{{ $formatDecimals(nextLevelDifference) }} USDT</span></div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import {mapState} from "vuex";
import Decimal from "decimal.js";

export default {
  name: 'transaction-details',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 分页相关
      loading: false,  // 是否处于加载状态
      finished: false, // 是否已加载完成所有数据
      error: false,    // 是否加载失败
      page: 1,         // 当前页码
      pageSize: 5,    // 每页数量

      // 数据
      transactionGroups: [],
      totalBuyAmount: '0',
      totalSellAmount: '0',
      nextLevelDifference: '0 '
    }
  },
  computed: {
    ...mapState([
      "accountInfo",
    ]),
  },
  watch: {
    show(val) {
      // 当弹窗显示时，重置数据并加载第一页
      if (val) {
        this.resetList();
      }
    }
  },
  methods: {
    // 格式化地址显示
    formatAddress(address) {
      if (!address) return '';
      return `${address.substring(0, 8)}...${address.substring(address.length - 8)}`;
    },
    resetList() {
      this.page = 1;
      this.finished = false;
      this.error = false;
      this.transactionGroups = [];
      // 不需要立即调用fetchTransactionDetails，因为van-list会自动触发onLoad
    },
    closePopup() {
      this.$emit('update:show', false);
    },
    formatHash(hash) {
      return hash; // 已经是格式化后的哈希
    },
    openExplorer(hash) {
      // 打开区块浏览器查看交易
      const fullHash = hash.replace('...', '');
      window.open(`https://bscscan.com/tx/${fullHash}`, '_blank');
    },
    // 加载更多数据
    onLoad() {
      // 调用获取交易详情的方法
      this.fetchTransactionDetails();
    },
    // 计算预计获取 Alpha 积分
    jsJs(num) {
      const alphaAmountDec = new Decimal(num);
      let points = 0;
      while (new Decimal(2).pow(points).lt(alphaAmountDec)) {
        points++;
      }
      if (new Decimal(2).pow(points).gt(alphaAmountDec)) {
        points--;
      }
      if (points < 0) {
        points = 0;
      }
      return points;
    },

    // 计算到下一个等级还需要多少 USDT
    calculateNextLevelDifference(currentAmount) {
      const currentPoints = this.jsJs(currentAmount);
      const nextLevelAmount = new Decimal(2).pow(currentPoints + 1);
      const difference = nextLevelAmount.minus(new Decimal(currentAmount));

      return difference;
    },
    // 获取交易详情数据
    fetchTransactionDetails() {
      const vm = this;
      vm.loading = true;

      // 添加分页参数
      vm.$axios.get(`/alpha/trade/infos?addr=${vm.accountInfo}&page=${vm.page}&size=${vm.pageSize}`)
          .then(response => {
            const {success, data} = response.data;
            if (success) {
              // 如果是第一页，直接赋值统计数据
              if (vm.page === 1) {
                vm.totalBuyAmount = data.todayBuyVol;
                vm.totalSellAmount = data.todaySellVol;
                vm.nextLevelDifference = vm.calculateNextLevelDifference(data.todayBuyVol);
              }

              // 追加交易列表数据
              if (data.tradeList && data.tradeList.length > 0) {
                vm.transactionGroups = [...vm.transactionGroups, ...data.tradeList];
                vm.page++;
              }

              // 判断是否已加载全部数据
              vm.finished = !data.tradeList || data.tradeList.length < vm.pageSize;
            } else {
              vm.error = true;
            }
          })
          .catch(error => {
            console.error('获取交易详情失败', error);
            vm.error = true;
          })
          .finally(() => {
            vm.loading = false;
          });
    },
  },
}
</script>

<style lang="scss" scoped>
.tx-details-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;

  .tx-list {
    flex: 1;
    overflow-y: auto;
    padding: 5px 16px;
  }

  .tx-group {
    margin-bottom: 16px;
  }

  .tx-date-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 5px 0;

    .tx-date {
      display: flex;
      align-items: center;
      color: #000;
      font-size: 12px;

      .calendar-icon {
        width: 16px;
        height: 16px;
      }

      span {
        padding-left: 5px;
      }
    }

    .tx-hash {
      color: #0052EB;
      font-size: 12px;
      cursor: pointer;
      //max-width: 100px;
      //overflow: hidden;
      //text-overflow: ellipsis;
      //white-space: nowrap;
    }
  }

  .tx-item-p {
    background-color: $bg;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 10px;
  }

  .tx-item {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .tx-tokens {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: $color1;
      .token-icon {
        display: flex;
        align-items: center;
        img {
          width: 20px;
          height: 20px;
          border-radius: 50%;

          &:last-child {
            margin-left: -8px;
          }
        }
      }

      .token-from{
        margin-left: 10px;
      }
      .arrow {
        display: block;
        margin: 0 4px;
        color: $color1;
        font-size: 14px;
      }
    }

    .tx-amount {
      font-size: 14px;

      &.positive {
        color: $up-color;
      }

      &.negative {
        color: $down-color;
      }
    }
  }

  .tx-summary {
    padding: 10px 16px 16px 16px;
    border-top: 0.5px solid $border;

    .summary-item {
      display: flex;
      align-items: center;
      margin-bottom: 8px;

      .summary-label {
        color: #000;
        font-size: 16px;
        font-weight: 500;
        padding-right: 6px;
      }

      .summary-value {
        font-weight: 500;
        font-size: 16px;

        &.positive {
          color: $up-color;
        }

        &.negative {
          color: $down-color;
        }
      }
    }

    .next-level {
      .next-level-text {
        color: $color1;
        font-size: 12px;
      }
    }
  }
}
</style>